import axios from 'axios'

const API_BASE_URL = process.env.API_HOST || 'http://localhost:8080/'

const publicHttpClient = axios.create({ baseURL: API_BASE_URL })

publicHttpClient.interceptors.response.use(function (response) {
  return Promise.resolve(response.data)
}, function (error) {
  return Promise.reject(error)
})

export default publicHttpClient
